<div [ngStyle]="{ width: dropdownWidth }">
  <pp-hide-dropdown (ppHideDropdown)="hideDropdown()"></pp-hide-dropdown>

  <ul class="dropdownWrapper">
    @for (item of items; track item) {
      <li
        (click)="selectItem(item)"
        class="dropdownItem"
        [ngStyle]="{ 'font-family': item.value }"
        [class.dropdownItem--selected]="selectedItem?.value === item.value"
        >
        {{ item.label }}
      </li>
    }
  </ul>
</div>
